<template>
  <div class="dal-slider">
    <flickity
      class="slides"
      ref="flickity"
      :options="flickityOptions"
    >
      <DalSliderItem
        v-for="(item, index) in slides"
        :key="index"
        :srcName="item.srcName"
      >
        <DalSliderTitle>{{ item.name }}</DalSliderTitle>
        <DalSliderAge>{{ item.age }}</DalSliderAge>
        <DalSliderContent>
          {{ item.content }}
        </DalSliderContent>
      </DalSliderItem>
    </flickity>
  </div>
</template>

<script>
import Flickity from 'vue-flickity'
import DalSliderItem from './DalSliderItem'
import DalSliderTitle from './DalSliderTitle'
import DalSliderAge from './DalSliderAge'
import DalSliderContent from './DalSliderContent'

export default {
  name: 'DalSlider',
  data () {
    return {
      flickityOptions: {
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        imagesLoaded: true
      },
      slides: [
        {
          name: 'Reyhan Cigdem',
          srcName: 'reyhan',
          age: 25,
          content: 'Op een gegeven moment zat ik bij de psycholoog en kwam mijn dankbaarheid terug. Ik dacht: wow, ik studeer aan de universiteit en ik heb toegang tot deze vrouw die mij wil helpen. Ik weet nog dat ik in haar kamer zat en naar buiten keek. Het sneeuwde. Voor het eerst dacht ik gewoon weer: jee, iets leuks. En toen moest ik huilen...'
        }, {
          name: 'Jimmy Meijvogel',
          srcName: 'jimmy',
          age: 35,
          content: 'Ik ben dragqueen en ik werk in het nachtleven. Het heeft me veel kracht gekost om daar terug naartoe te gaan. Maar m’n hart ligt daar. Ik kon niet anders, ik móest terug. Mijn advies: wees eerlijk. Houd het niet voor jezelf. Als je een ochtend wakker wordt en denkt ‘ik wil niet meer’, spreek dat dan uit. Wees daar niet bang voor.'
        }, {
          name: 'Tom Oord',
          srcName: 'tom',
          age: 22,
          content: 'Het kantelde toen ik aan de xtc zat in het Vondelpark. Met een vriend heb ik toen urenlang vrijuit gepraat over alles. We hebben het over zware onderwerpen gehad, op een lichte manier. Ik probeerde het eerder ook wel te delen met mensen, maar toen voelde ik te veel remmingen. Dat het nu wel kon was echt een belangrijke stap.'
        }, {
          name: 'Ivo Noort',
          srcName: 'ivo',
          age: 34,
          content: 'Ik heb geleerd te accepteren. Ik weet nu: oké, ik voel me nu rot, maar over een uur kan het anders zijn. En dan laat ik het gewoon even voor wat het is. Ik ben nu niet meer depressief, maar heb af en toe wel nog momenten dat ik denk: pfff. Ik denk dat ik daar nooit meer vanaf kom. Maar je kan de uitdaging aangaan, of je kan vluchten.'
        }, {
          name: 'Maayke Schlee',
          srcName: 'maayke',
          age: 29,
          content: 'Wat me goed helpt is therapie. Daar ga ik een keer in de week heen om met iemand te praten. Ook traumatherapie werkt goed. Daardoor herinnerde ik me ineens weer allemaal dingen van vroeger, die ik altijd heb weggestopt. Ik hoop dat ik daardoor wat minder vaak depressief ben.'
        }, {
          name: 'Helene Phoa',
          srcName: 'helene',
          age: 29,
          content: 'Mijn geluksmomenten op dit moment in mijn leven? Dat is wanneer ik bijvoorbeeld een goeie dag heb in de buitenlucht. Dan zie ik hoe blauw de lucht is en hoe geel de narcissen zijn. En dat ik daar een glimlach van krijg. Dat ik bij mezelf besef dat ik dat weer kán. Zeker twee jaar terug had ik eigenlijk niet meer gedacht dat dat kon.'
        }
      ]
    }
  },
  components: {
    Flickity,
    DalSliderItem,
    DalSliderTitle,
    DalSliderAge,
    DalSliderContent
  }
}
</script>

<style lang="scss" scoped>
.dal-slider {
  width: 100%;
  margin: 57px auto 0;
}
.slides {
  outline: 0;
}
</style>
<style lang="scss">
.dal-slider {
  .flickity-page-dots {
    position: static;
    bottom: 0;
    margin-top: 31px;
    font-size: 0;

    .dot {
      background-color: rgba(#313345, 0.2);
      opacity: 1;
      width: 13px;
      height: 13px;
      margin: 0 5px;
      will-change: opacity;
      transition: opacity 200ms ease;
      position: relative;

      &:hover {
        opacity: 0.8;
      }
      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: $c-red;
        transform: scale(0);
        z-index: 1;
        transition: transform 400ms ease;
        will-change: transform;
        border-radius: 50%;
      }

      &.is-selected {
        &:after {
          transform: scale(1);
        }
      }
    }
  }
  .flickity-button {
    background-color: $c-red;
    color: white;
    cursor: pointer;
    position: absolute;

    @media (max-width: 767px) {
      display: none;
    }
  }
  .flickity-prev-next-button .flickity-button-icon {
    left: 30%;
    top: 30%;
    width: 40%;
    height: 40%;
  }
  .flickity-button-icon {
    fill: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dal/DalSlider.vue